import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  useAuthentication,
  useChangePlanzone,
  useLogOut,
  usePlanzonesRetrieval,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { Loader } from "@common/loader";
import { ShortLogo } from "@common/shortLogo";
import { LayoutWatcher } from "@common/layoutWatcher";
import { ScreenWatcher } from "@common/screenWatcher";
import { usePlanzonePermissions } from "@components/permissions";

import { Props } from "./types";
import styles from "./styles.scss";
import { Logo } from "@common/logo";
import { LogoLoader } from "@components/logoLoader";

function Menu(props: Props) {
  const { t } = useTranslation();
  const { isRequestPending, logOut } = useLogOut();
  const { account } = useAuthentication();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { planzones } = usePlanzonesRetrieval();
  const { changePlanzone } = useChangePlanzone();
  const { isAdministrator } = usePlanzonePermissions();

  return (
    <ScreenWatcher
      renderChildren={({ height }) => (
        <LayoutWatcher
          renderChildren={({ top }) => {
            const maxHeight = height - top - 60;

            return (
              <div
                className={styles.menu}
                style={{
                  maxHeight:
                    maxHeight < 320 && maxHeight > 100 ? maxHeight : 320,
                }}
              >
                <div className={styles.planzone}>
                  <Logo className={styles.shortLogo} />
                  <h1 className={styles.planzoneName}>{planzone.name}</h1>
                </div>
                <div className={styles.planzones}>
                  {planzones
                    .filter(({ uuid }) => uuid !== planzone.uuid)
                    .map((planzone) => (
                      <div
                        key={planzone.uuid}
                        className={styles.planzoneItem}
                        onClick={() => changePlanzone({ account, planzone })}
                      >
                        {!!planzone.data.logo ? (
                          <LogoLoader planzone={planzone}>
                            <Logo className={styles.planzoneLogo} />
                          </LogoLoader>
                        ) : (
                          <div className={styles.tick} />
                        )}
                        <p className={styles.name}>{planzone.name}</p>
                      </div>
                    ))}
                </div>
                <ul className={styles.navigation}>
                  <li className={styles.item}>
                    <Link to="/account" className={styles.text}>
                      {t("profile.menu.preferences")}
                    </Link>
                  </li>
                  {isAdministrator && (
                    <li className={styles.item}>
                      <Link to="/planzone/parameters" className={styles.text}>
                        {t("profile.menu.planzoneParameters")}
                      </Link>
                    </li>
                  )}
                </ul>
                <button className={styles.logOut} onClick={logOut}>
                  {isRequestPending ? (
                    <div className={styles.loader}>
                      <Loader />
                    </div>
                  ) : (
                    <p>{t("profile.menu.logOut")}</p>
                  )}
                </button>
              </div>
            );
          }}
        />
      )}
    />
  );
}

export { Menu };
